import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  casesPage: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  casesSearchWrapper: {
    padding: '0rem 1.5rem 1rem 1.5rem'
  }
}));

export default useStyles;
